import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

import { useEmailDecisionMakerModalBase } from '../useEmailDecisionMakerModalBase';

type StarterCanEmailDmModal = ReturnType<typeof useEmailDecisionMakerModalBase>;
type Options = Parameters<StarterCanEmailDmModal>[0];

export function useEmailDecisionMakerModal(): (options: Options) => Promise<void> {
	const openModal = useEmailDecisionMakerModalBase();

	const pageData = useStarterDashboardV2PageData();

	return useCallback(async () => {
		await openModal({ pageData }).waitForClosed();
	}, [openModal, pageData]);
}
